if (!window.FreshityViewMore) {
  class FreshityViewMore {
    constructor() {
      this.onClick = this.onClick.bind(this);
      this.init();
      document.addEventListener('shopify:section:load', () => this.init());
    }

    init() {
      document.querySelectorAll('[data-view-more]').forEach((wrapper) => {
        const button = wrapper.querySelector('[data-view-more-button]');
        if (!button || button.dataset.viewMoreBound) return;
        button.dataset.viewMoreBound = 'true';
        button.addEventListener('click', this.onClick);
      });
    }

    async onClick(event) {
      event.preventDefault();
      const button = event.currentTarget;
      const wrapper = button.closest('[data-view-more]');
      const url = wrapper.dataset.nextUrl;
      const gridId = wrapper.dataset.gridId;
      const sectionId = wrapper.dataset.sectionId;
      const label = button.querySelector('[data-view-more-label]');
      const status = wrapper.parentElement.querySelector('[data-view-more-status]');
      const originalLabel = label.textContent;

      button.setAttribute('aria-busy', 'true');
      button.classList.add('freshity-view-more__button--loading');
      label.textContent = button.dataset.loadingLabel || 'Loading...';

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const liveGrid = document.querySelector(`#${gridId}[data-id="${sectionId}"]`);
        const fetchedGrid = doc.querySelector(`#${gridId}[data-id="${sectionId}"]`);

        let addedCount = 0;
        if (liveGrid && fetchedGrid) {
          const newItems = Array.from(fetchedGrid.children);
          newItems.forEach((item) => liveGrid.appendChild(item));
          addedCount = newItems.length;
        }

        const fetchedWrapper = doc.querySelector(
          `[data-view-more][data-section-id="${sectionId}"][data-grid-id="${gridId}"]`
        );

        if (fetchedWrapper) {
          wrapper.dataset.nextUrl = fetchedWrapper.dataset.nextUrl;
          button.setAttribute('href', fetchedWrapper.dataset.nextUrl);
          label.textContent = originalLabel;
        } else {
          wrapper.remove();
        }

        if (status) {
          status.textContent = addedCount
            ? `${addedCount} more products loaded`
            : 'No more products to load';
        }
      } catch (error) {
        window.location.href = url;
        return;
      } finally {
        button.removeAttribute('aria-busy');
        button.classList.remove('freshity-view-more__button--loading');
      }
    }
  }

  window.FreshityViewMore = new FreshityViewMore();
}
